<template>
  <PublicPopup ref="PopupRef">
    <template #content>
      <div class="user-agreement-popup chxy-column-c-c">
        <p class="title">Acordo do Usuário</p>
        <div class="user-agreement-content">
          <p class="paragraph">
            1. Para evitar disputas de apostas, os membros devem ler as regras da empresa antes de
            entrar no aplicativo. Uma vez que o jogador“ Eu concordo” Ao entrar nesta empresa para
            apostar, será considerado que você está de acordo com o Acordo do Usuário da empresa.
          </p>
          <p class="paragraph">
            2. É de responsabilidade do membro garantir a confidencialidade de sua conta e
            informações de login. Quaisquer apostas online feitas com o seu número de conta e senha
            de membro serão consideradas válidas. Por favor, altere sua senha de tempos em tempos. A
            empresa não se responsabiliza por qualquer compensação de apostas feitas com conta e
            senha roubadas.
          </p>
          <p class="paragraph">
            3. A empresa reserva-se o direito de alterar este acordo ou as regras do jogo ou as
            regras de confidencialidade de tempos em tempos. Os termos modificados entrarão em vigor
            na data especificada após a ocorrência da alteração, e o direito de tomar decisões
            finais sobre todas as disputas é reservado à empresa.
          </p>
          <p class="paragraph">
            4. Os usuários devem ser maiores de idade de acordo com as leis do país de residência
            para usar cassino ou aplicativo online. As apostas online que não tenham sido submetidas
            com sucesso serão consideradas nulas.
          </p>
          <p class="paragraph">
            5. Quando um jogador é desconectado automaticamente ou forçosamente do jogo antes que o
            resultado do jogo seja divulgado, isso não afetará o resultado do jogo.
          </p>
        </div>
        <div class="button" @click="handlePopupClose">Eu li e aceito</div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
const PopupRef = ref(null)
const open = () => {
  nextTick(() => {
    PopupRef.value.open()
  })
}
const handlePopupClose = () => {
  PopupRef.value.close()
}

const emit = defineEmits(['close'])

defineExpose({
  open,
})
</script>

<style lang="scss" scoped>
.user-agreement-popup {
  width: 75vw;
  .title,
  .paragraph {
    font-size: 11px;
    color: var(--user-agreement-popup-content-text);
  }

  .title {
    text-align: center;
  }

  .user-agreement-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 60px auto 20px;
    padding: 0 10px;
    line-height: 1.2;
    overflow-y: auto;
  }
  .button {
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    background: var(--user-agreement-popup-confirm-bg);
    color: var(--user-agreement-popup-confirm-text);
    font-size: 14px;
    border-radius: 7px;
  }
}
</style>
